import removeLowestHighestEntries from "./remove_lowest_highest_entries";

export const tableTotalAvg = (amtTable, includeCurrentTurn, tossHighLow) => {
    let averageAmt = 0;
    let totalAmt = 0;
    if (includeCurrentTurn === undefined){
        includeCurrentTurn = true;
    }
    if (!tossHighLow){
        tossHighLow = false;
    }
   
    let newAmtTable = [];
    if (amtTable && amtTable.length > 0){
        newAmtTable = JSON.parse(JSON.stringify(amtTable));
    }
    if (tossHighLow === true && newAmtTable.length > 4){
        newAmtTable = removeLowestHighestEntries(newAmtTable);
    }
     
    let nbrOfEntries = newAmtTable.length;
    for (let i=0; i<nbrOfEntries; i++){
        totalAmt += +newAmtTable[i];
    }
    if (nbrOfEntries === 0){
        averageAmt = 0;
    }else{
        averageAmt = (totalAmt / nbrOfEntries).toFixed(2);
    }
    const returnObj = {totalNbr: newAmtTable.length, totalAmt: totalAmt, averageAmt: averageAmt}
    return returnObj;

    }
export default tableTotalAvg;